<div class="d-inline-flex flex-nowrap input-group">
  <span *ngIf="props.prependText" [ngClass]="props.prependTextClass || 'input-group-text'">{{
    props.prependText
  }}</span>

  <!-- CHAT-939: a call site chooses a ROLE, not a class. The old prop took an
       arbitrary class string and defaulted to `btn btn-outline-secondary`,
       which is how Bootstrap kept reaching a Formly field nobody was looking
       at. themeColor is Kendo's own input, so there is nowhere to put a
       sixth variant. -->
  <button
    *ngIf="props.prependButtonText"
    kendoButton
    [themeColor]="props.prependButtonThemeColor || 'base'"
    type="button"
    (click)="onPrependButtonClick()">
    {{ props.prependButtonText }}
  </button>

  <input
    #phoneInput
    type="tel"
    class="form-control"
    [formlyAttributes]="field"
    [class.is-invalid]="showError"
    [placeholder]="props.placeholder || ''"
  />

  <span *ngIf="props.appendText" [ngClass]="props.appendTextClass || 'input-group-text'">{{
    props.appendText
  }}</span>

  <button
    *ngIf="props.appendButtonText"
    kendoButton
    [themeColor]="props.appendButtonThemeColor || 'base'"
    type="button"
    (click)="onAppendButtonClick()">
    {{ props.appendButtonText }}
  </button>
</div>